import PropTypes from 'prop-types'
import { Table } from 'baseui/table-semantic'
import { useTranslation } from 'react-i18next'
import { SIZE } from 'baseui/input'
import { Spinner } from 'baseui/spinner'

const FeedbackList = ({ items, isLoading }) => {
  const { t } = useTranslation()
  const columns = [
    t('devTools:feedback.date'),
    t('devTools:feedback.agent_firstname'),
    t('devTools:feedback.agent_name'),
    t('devTools:feedback.feedback_response'),
    t('devTools:feedback.comment'),
    t('devTools:feedback.subscriber_fullname'),
  ]
  return (
    <Table
      size={SIZE.compact}
      columns={columns}
      data={items}
      emptyMessage={
        isLoading
          ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Spinner size={24} /> {t('devTools:feedback.loading')}
            </div>
          )
          : <h1>{t('devTools:feedback.no_result')}</h1>
      }
    />
  )
}

FeedbackList.propTypes = {
  items: PropTypes.array,
  isLoading: PropTypes.bool
}
export default FeedbackList
